/**
 * Use as a span/empty module
 * E.g. when you need to provide a common functionality for the Portal
 * use a Webpack alias "x": "empty-module" , so the module import doesn't fail.
 * Then override the alias for a specific Portal
 */

export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/empty-module.js
// module id = 872
// module chunks = 0